module.exports = __webpack_public_path__ + "img/32_player.3110e716.png";